export default {
      id: "monthgrid-usage",
      viewBox: "0 0 17 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#monthgrid",
      toString: function () {
        return this.url;
      }
    }